<template>
    <CieloLayout layout-version="v1">
        <div class="invalid-order">
            <div class="invalid-order__container">
                <img class="invalid-order__img" src="@/assets/img/generic-error.svg" alt="" tabindex="-1" />
                <h1 class="invalid-order__title" v-text="$ml.get('invalidOrderTitle')" tabindex="0" />
                <p class="invalid-order__text" v-text="$ml.get('invalidOrderText')" tabindex="0" />
            </div>
            <div class="invalid-order__cta" v-if="orderId">
                <CieloButton
                    class="invalid-order__button"
                    @click="goToPreviousView"
                >
                    <span v-text="$ml.get('update')" />
                </CieloButton>
            </div>
        </div>
    </CieloLayout>
</template>

<script>
  const CieloLayout = () => import(
      /* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
  );
  const CieloButton = () => import(
	    /* webpackChunkName: "cielo-button" */ '@/components/template/CieloButton'
  );
  import { mapGetters } from 'vuex';

  export default {
      components: {
          CieloLayout,
          CieloButton
      },

      computed: {
          ...mapGetters({
              orderId: 'orderStatus/getOrderId',
          })
      },

      methods: {
          goToPreviousView() {
              this.$store.dispatch('pipeline/pushToOrderStatus', this.orderId);
          }
      }
  };
</script>

<style lang="scss" scoped>
  .invalid-order {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1 0 auto;

      &__container {
          flex: 1 0 auto;
          text-align: center;
          max-width: 328px;
          
          @media screen and (min-width: 1025px) {
              max-width: 580px;
              flex: 0 0 auto;
          }
      }

      &__img {
          width: 200px;
          height: 200px;
          margin-bottom: 24px;
      }

      &__title {
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 20px;
          font-weight: 700;
          color: #2F363E;
      }

      &__text {
          font-size: 16px;
          line-height: 24px;
          color: #5C6A7B;
          margin-bottom: 24px;
      }

      &__cta {
          width: 100%;

          @media screen and (min-width: 1025px) {
              max-width: 124px;
          }
      }
  }
</style>